export enum TrapTableType {
  MultiCatchMouseTraps = 'Multi-catch mouse traps',
  SmartRodenBaitModule = 'Smart rodent bait modules',
  SnapTrapMouse = 'Snap traps (mouse)',
  SnapTrapRat = 'Snap traps (rat)',
  Hubs = 'Hubs',
  BaitStations = 'Bait stations',
  CrawlingInsectsTrap = 'Crawling insects trap',
  FeromonTraps = 'Feromon traps',
}
export enum TrapTableTypeLink {
  MultiCatchMouseTraps = 'mct',
  SmartRodenBaitModule = 'srbm',
  SnapTrapMouse = 'smst',
  SnapTrapRat = 'srst',
  Hubs = 'hubs',
}
